import useSWR, { SWRResponse } from 'swr';
import { getCellarsByPropertyId } from '../../../providers/api/cellar/cellarProvider';
import { Cellar } from '../../../providers/api/dtos';

export const PROPERTY_CELLARS_RID = '/properties/:id/cellars';

export default function useCellars(propertyId?: number): SWRResponse<Cellar[], Error> {
  return useSWR(propertyId ? [PROPERTY_CELLARS_RID, propertyId] : null, () => getCellarsByPropertyId(propertyId!));
}
